import { Wizard } from "@/components/instance/LaunchInstanceWizard";
import { useLocation } from "react-router-dom";

export const LaunchInstance = () => {
  const location = useLocation();
  const { key, resource } = location.state || {};

  return (
    <Wizard
      instanceType={key}
      resource={resource}
      title="actions.launchInstance"
      description="actionsDesc.launchInstance"
      submitIdx={0}
    />
  );
};
